import React, { Component } from 'react';
import { Route } from 'react-router';
// import Orders from './orders.component';
// import Transactions from './transactions.component'
import DealerList from './../view/dealer/component/dealer-list';
import ManagerList from './../view/accountManager/component/account-manager-list';
import AddAccountManager from './../view/accountManager/component/add-account-manager';
import ResetAccountBlock from './../view/dealer/component/ResetAccountBlock';
import SuperAdminReport from './../view/dealer/component/SuperAdminReport';
import SalesSupportUsers from './../view/salesSupportUsers/SalesSupportUsersList';
import InventoryFunding from '../view/inventory-funding/component/InventoryFunding';
import SkuPannel from '../view/skus/SkuPannel';
import EditCreateSkuForm from '../view/skus/EditCreateSkuForm';
import DealerSubscriptionPannel from '../view/subscription/DealerSubscriptionPannel';
import DealerSubscriptionList from '../view/subscription/DealerSubscriptionList';
import SkuTransactionPannel from '../view/skusTransactions/SkuTransactionPannel';
import ModalBuySubscriptions from '../view/subscription/ModalBuySubscriptions';
import OtpLookup from '../view/dealer/component/OtpLookup';
// import NotFound from './../view/common/NotFound';

class AdminRoute extends Component {
    render() {
        const { match: { path } } = this.props;
        return (
            <div>
                <Route path={`${path}/dealer-list`} component={DealerList} />
                <Route path={`${path}/reset-account-block`} component={ResetAccountBlock} />
                <Route path={`${path}/check-otp-details`} component={OtpLookup} />
                <Route path={`${path}/super-admin-report`} component={SuperAdminReport} />
                <Route path={`${path}/ac-manager`} component={ManagerList} />
                <Route path={`${path}/add-manager`} exact component={AddAccountManager} />
                <Route path={`${path}/add-manager/:ac_manager_id`} component={AddAccountManager} />
                <Route path={`${path}/sales-support-users`} component={SalesSupportUsers} />
                <Route path={`${path}/inventory-funding`} component={InventoryFunding} />
                <Route path={`${path}/subscriptions`} component={DealerSubscriptionPannel} />
                <Route path={`${path}/subscriptions-list`} component={DealerSubscriptionList} />
                <Route path={`${path}/dealer/subscription/buy/:skuId`} component={ModalBuySubscriptions} />
                <Route exact path={`${path}/dealer_sku`} component = {SkuPannel} />
                <Route path={`${path}/dealer_sku/create`} component = {EditCreateSkuForm} />
                <Route path={`${path}/dealer_sku/edit/:id`} component={EditCreateSkuForm} />
                <Route path={`${path}/sku/transaction_list`} component={SkuTransactionPannel} />

                {/* <Route path="/*"
                    component={NotFound} /> */}
            </div>
        );
    }
}

export default AdminRoute;